import React from 'react';

import { type Location, Navigate, Outlet } from 'react-router-dom';

import SystemRedirect, { RedirectType } from '@app/helpers/classes/Redirect';
import { useCheckUserGlobalRedirects } from '@app/routes';

type State = Pick<Location, 'state'>;

interface RedirectWrapperProps {
    redirectTo?: string;
    state?: State;
}
export const RedirectWrapper = ({ redirectTo, state }: RedirectWrapperProps) => {
    const systemRedirectPath = SystemRedirect.getRedirect(RedirectType.Default);

    const userRedirectTo = useCheckUserGlobalRedirects();
    const redirectPath = redirectTo || userRedirectTo;
    if (systemRedirectPath === redirectPath) {
        SystemRedirect.removeRedirect(RedirectType.Default);
    }
    return redirectPath ? <Navigate replace to={redirectPath} state={state} /> : <Outlet />;
};
